// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__TQZBn","tab":"ProcedureTabs_tab__1-eJN"};